import { SET_LEAD_GATE } from '../actions/types';

export default function leadGate(state = {}, action) {
    if (!action.error && action.payload !== undefined) {
        switch (action.type) {
            case SET_LEAD_GATE:
                return action.payload;
            // no default
        }
    }

    return state;
}
